import { AttachmentsList } from "../../file";

export default function MessageAttachments(props) {
    return (
        <div className="attachments">
            <AttachmentsList attachments={props.attachments} />
        </div>
    );
}